import { useGlobalState } from 'com-ui2/hooks'
import { useRouter } from 'next/router'
import { CMS_LOCAL_SIGN_UP } from 'src/helpers'
import { PublisherRegister } from 'src/services'
import { SignUp } from 'src/signup'
import { useEffect } from 'react'

export default function Page() {
  const router = useRouter()
  const [registerData] = useGlobalState<PublisherRegister | null>(CMS_LOCAL_SIGN_UP)
  useEffect(() => {
    if (registerData) {
      router.push(`/sellers/signup-2${window.location.search}`)
    }
  }, [])
  return !registerData ? <SignUp /> : <></>
}
